import * as Types from '../types/types.generated';

import { gql } from '@apollo/client';
import { KeywordTagFieldsFragmentDoc } from './keywordTagFields.generated';
export type BasicRegulationFieldsFragment = { __typename?: 'Regulation', id: string, regulationNumber: string, name: string, summary: string, markets: Array<{ __typename?: 'Market', id: string, name: string }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, standardPlusPcmsClusters: Array<{ __typename?: 'StandardPlusPcmsCluster', id: string, name: string }>, contactPersons: Array<{ __typename?: 'User', name: string, id: string }> };

export type BasicRegulatoryDocumentFieldsFragment = { __typename?: 'RegulatoryDocument', id: string, name: string, status: Types.RegulatoryDocumentStatus, summary?: string | null, modelYear?: number | null, dateEffective?: any | null, dateExpiration?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, regulation?: { __typename?: 'Regulation', name: string, regulationNumber: string } | null, markets: Array<{ __typename?: 'Market', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, contactPersons: Array<{ __typename?: 'User', name: string, id: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus }, phaseOut: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }>, phaseIn: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> };

export type BasicRegulatoryDocumentParaFieldsFragment = { __typename?: 'RegulatoryDocumentParagraph', level: number, id: string, enumeration: string, modelYear?: number | null, comprehensive?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, position: number, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, categories: Array<{ __typename?: 'Category', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, phaseIn?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, phaseOut?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, elements: Array<{ __typename?: 'RegulatoryDocumentParagraphElement', assetId?: string | null, bounds?: Array<number> | null, csvContent?: string | null, isHeader: boolean, page: number, text?: string | null, textPosition?: Types.TextPosition | null, type: Types.ParagraphElementType, asset?: { __typename?: 'BlobRef', contentType: string, fileName: string, originalFileName?: string | null, uri: any } | null }> };

export type BasicRequirementFieldsFragment = { __typename?: 'Requirement', id: string, name: string, status: Types.RequirementStatus, definition?: string | null, requirementId?: string | null, markets: Array<{ __typename?: 'Market', id: string, name: string }>, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, engineVariants: Array<{ __typename?: 'EngineVariant', id: string, name: string }>, gearboxVariants: Array<{ __typename?: 'GearboxVariant', id: string, name: string }>, bodyworkVariants: Array<{ __typename?: 'BodyworkVariant', id: string, name: string }>, activeTypeMarkets: Array<{ __typename?: 'ActiveTypeMarket', id: string, name: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, systemLevels: Array<{ __typename?: 'SystemLevel', id: string, name: string }>, createdBy: { __typename?: 'User', name: string, id: string } };

export type BasicPogisFieldsFragment = { __typename?: 'PogisDocument', associations?: Array<string> | null, createdAt?: any | null, docStatus: string, editor: string, id: string, keywords: Array<string>, linkVersion?: string | null, markets: Array<string>, modifiedAt?: any | null, pogisId: string, regulationStatus: string, relatedDocuments?: Array<string> | null, shortInfo: string, standards?: Array<string> | null, pogisAttachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, file: { __typename?: 'BlobRef', fileName: string, uri: any }, category?: { __typename?: 'AttachmentCategory', name: string } | null }> | null, dates: Array<{ __typename?: 'PogisDate', date: any, dateType: string }> };

export const BasicRegulationFieldsFragmentDoc = gql`
    fragment BasicRegulationFields on Regulation {
  id
  regulationNumber
  name
  summary
  markets {
    id
    name
  }
  mainKeywords {
    id
    name
  }
  keywords {
    ...KeywordTagFields
  }
  standardPlusPcmsClusters {
    id
    name
  }
  contactPersons {
    name
    id
  }
}
    ${KeywordTagFieldsFragmentDoc}`;
export const BasicRegulatoryDocumentFieldsFragmentDoc = gql`
    fragment BasicRegulatoryDocumentFields on RegulatoryDocument {
  id
  name
  status
  summary
  regulation {
    name
    regulationNumber
  }
  markets {
    id
    name
  }
  keywords {
    ...KeywordTagFields
  }
  mainKeywords {
    id
    name
  }
  contactPersons {
    name
    id
  }
  vehicleCategories {
    id
    name
  }
  driveVariants {
    id
    name
  }
  workflow {
    status
  }
  phaseOut {
    date
    status
  }
  phaseIn {
    date
    status
  }
  modelYear
  dateEffective
  dateExpiration
  dateNewRegistration
  dateNewTypes
}
    ${KeywordTagFieldsFragmentDoc}`;
export const BasicRegulatoryDocumentParaFieldsFragmentDoc = gql`
    fragment BasicRegulatoryDocumentParaFields on RegulatoryDocumentParagraph {
  level
  id
  enumeration
  keywords {
    ...KeywordTagFields
  }
  categories {
    id
    name
  }
  driveVariants {
    id
    name
  }
  vehicleCategories {
    id
    name
  }
  modelYear
  comprehensive
  dateNewRegistration
  dateNewTypes
  phaseIn {
    date
    status
  }
  phaseOut {
    date
    status
  }
  position
  elements {
    assetId
    bounds
    csvContent
    isHeader
    page
    text
    textPosition
    type
    asset {
      contentType
      fileName
      originalFileName
      uri
    }
  }
}
    ${KeywordTagFieldsFragmentDoc}`;
export const BasicRequirementFieldsFragmentDoc = gql`
    fragment BasicRequirementFields on Requirement {
  id
  name
  status
  definition
  requirementId
  markets {
    id
    name
  }
  vexClusters {
    id
    name
  }
  driveVariants {
    id
    name
  }
  engineVariants {
    id
    name
  }
  gearboxVariants {
    id
    name
  }
  bodyworkVariants {
    id
    name
  }
  activeTypeMarkets {
    id
    name
  }
  vehicleCategories {
    id
    name
  }
  keywords {
    id
    name
  }
  systemLevels {
    id
    name
  }
  createdBy {
    name
    id
  }
}
    `;
export const BasicPogisFieldsFragmentDoc = gql`
    fragment BasicPogisFields on PogisDocument {
  associations
  createdAt
  docStatus
  editor
  id
  keywords
  linkVersion
  markets
  modifiedAt
  pogisId
  regulationStatus
  relatedDocuments
  shortInfo
  standards
  pogisAttachments {
    file {
      fileName
      uri
    }
    attachmentId
    category {
      name
    }
  }
  dates {
    date
    dateType
  }
}
    `;